import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayNationalPark extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Subject <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Wrangell St. Elias National Park Research</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>The relationships between the Department of the Interior, the Wrangell St. Elias National Park Service and the Park itself contribute to the successful development and maintenance of the ecosystem’s integrity.</p>

              <div className={styles.comment}>
                <ul>
                  <li>Content: The instructions are followed, as the paper answers the required question “Discuss relationships between the Department of the Interior, National Park Service, and Wrangell-St. Elias National Park” explicitly. </li>
                  <li>Structure: The introduction contains an arguable thesis statement that addresses the topic.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>I plan to research Wrangell St. Elias National Park because of its unique biological, geographical and archeological features. It is worth being investigated in details, because of the richness of species and nature preserved. The park’s territory was referred to as a National Monument in 1978, and in a year the park became designated as a World Heritage site. Nowadays, Wrangell St. Elias Park is the largest national park in the United States, and it is six times the size of the Yellowstone National Park that owns 2.2 million acres (Fensterman 4). According to the recent data regarding the park’s geological features, approximately 35% of the territory is covered by glaciers (Nps.Gov N.p.). The size and diversity of the park make it one of the tourists’ favorite places.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph answers the required questions “why this park interests you, when it was designated as a National Park, what are its geological features” explicitly.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in MLA. The paragraph finishes with a transition sentence.</li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>The main purposes of the Park are to maintain, protect and ensure the further existence of the park in the ecosystem integrity. It is significant to protect the wildlife populations and their habitats, as well as carefully plan the public use in order. These goals are integral for the creation of the future opportunity for the continuation of subsistence lifestyles, interpretation of natural forces, future scientific investigations, as well as the “inspiration for wilderness experience for the next generations” (Nps.Gov N.p.). The relationships between the Department of the Interior, National Park Service, and Wrangell-St. Elias National Park contribute to meeting those entire requirements and regulate the use of the park itself.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with an example from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>Constant control conducted by the National Park Service and the cooperation between the services help understand the condition of Wrangell-St. Elias National Park and grant its successful development in future. </p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis.</li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">

            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>Fensterman, Greg. <i>Hiking Alaska's Wrangell-St. Elias National Park And Preserve.</i> 1st ed., </div>
              <p>Globe Pequot Press, 2011.</p>

              <div>“What's So Special About This Place?”. <i>Nps.Gov</i>, </div>
              <p>https://www.nps.gov/stateoftheparks/wrst/naturalresources/naturalresources.cfm</p>
              <p>Accessed 27 June 2018.</p>


              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style. </li>
                  <li>In case the paper contains more than one source, the list should be alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayNationalPark);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayNationalPark.js